import axiosInstance from './axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const inviteToEditSelectedResources = async (searchResults = null, userName = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!searchResults) {
        console.log("no searchResults");
        return null;
    }
    let selectedResources = searchResults.filter(result => result.selectedToRetire).map(result => result.targetfoi);
    if (!selectedResources.length) {
        alert("no resources selected to invite others to");
        return null;
    }
    console.log(fevir_node_server_address);
    let inviteCodeRetrieved = await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getinvitecodeformultipleresources',
            'createinvitelink': true,
            'resourceids': selectedResources,
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true, 'newinvitecreated': true, 'invitecode': "inviteCode" }
            if (resp.data?.success && resp.data.invitecode) {
                return resp.data.invitecode;
            } else {
                console.log("FAILED RESPONSE from getinvitecodeforresource call")
                return null;
            }
        }
        console.log("NO RESPONSE from getinvitecodeforresource call");
    }).catch((error) => { console.log(error); });

    if (inviteCodeRetrieved) {
        console.log(inviteCodeRetrieved);
        return `You're invited by ${userName} to become an editor for multiple resources.\nYou can accept this invite by going to this URL, be logged in, and then click the Accept button.\nhttps://fevir.net/invite/${inviteCodeRetrieved}`;
    }

    /*
    let notInvitedToEditList = [];
    for (const result of selectedResources) {
        const foi = result.targetfoi;
        if (foi) {
            console.log("CALLING SERVER with retireresource " + foi);
            await axiosInstance({
                method: 'POST',
                url: fevir_node_server_address,
                timeout: 120000,
                data: {
                    //'functionid': 'retireresource',
                    'apiToken': apiToken,
                    'foi': foi,
                },
            }).then((resp) => {
                if (resp?.data) {
                    if (!resp.data.success) {
                        notInvitedToEditList.push(foi);
                        if (resp.data.message) {
                            alert(resp.data.message);
                        }
                    }
                } else {
                    console.log("NO RESPONSE from call");
                }
            }).catch((error) => { console.log(error); });
        } else {
            alert("Result missing FOI");
        }
    }
    if (notInvitedToEditList.length > 0) {
        alert("The following Resources haven't had invites created: " + notInvitedToEditList.join(", "));
    } else {
        alert("Selected Resources did not create an invite for.");
    }
        */
};

export default inviteToEditSelectedResources;